import DashboardLayout from "@/components/DashboardLayout";
import { PermissionGuard } from "@/components/PermissionGuard";
import McpTokensPanel from "@/components/McpTokensPanel";
import { Plug } from "lucide-react";

/**
 * Página per-user de conexão de IAs externas via MCP.
 *
 * Existe fora de Configurações de propósito: a aba MCP de lá vive atrás de
 * settings:view, que usuário comum não tem. Aqui o gate é só
 * settings:mcp_tokens — e o McpTokensPanel opera exclusivamente sobre os
 * tokens do próprio usuário (o server ignora qualquer userId de input).
 */
export default function ConectarIA() {
  return (
    <PermissionGuard permission="settings:mcp_tokens">
      <DashboardLayout>
        <div className="p-4 md:p-6 max-w-3xl mx-auto space-y-4">
          <div>
            <h1 className="text-lg font-semibold flex items-center gap-2">
              <Plug className="h-5 w-5 text-primary" />
              Conectar IA
            </h1>
            <p className="text-sm text-muted-foreground mt-1">
              Conecte o Claude e outros assistentes de IA à sua conta do
              LeadConversa. Cada conexão enxerga somente o que você já enxerga
              aqui no painel — nem mais, nem menos — e pode ser revogada a
              qualquer momento.
            </p>
          </div>
          <McpTokensPanel />
        </div>
      </DashboardLayout>
    </PermissionGuard>
  );
}
